export default __webpack_public_path__ + "img/743f91d97a6997cf1e70f4a3b68e4c4a.png";